const ReferenceSection = ({ reference, setDataCreateMission }) => (
  <div className="flex flex-col gap-4">
    <div className="ft-xl">Référence</div>
    <input
      type="text"
      value={reference}
      placeholder="Référence interne (optionnel)"
      className="w-full h-10 px-3 ft-b placeholder-gray-600 border rounded-lg text-sm"
      onChange={(e) =>
        setDataCreateMission((prev) => ({ ...prev, reference: e.target.value }))
      }
    />
  </div>
);

export default ReferenceSection;
